import React, { useState, useEffect } from 'react';
import './PedidosRecientes.css';
import baseURL from '../../url';
import moneda from '../../moneda';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faEye,
    faClock,
    faQrcode,
    faUserTie,
    faCashRegister,
    faSync,
    faUtensils,
    faCheckCircle,
    faExclamationTriangle,
    faTimes
} from '@fortawesome/free-solid-svg-icons';
import { Link as Anchor } from 'react-router-dom';

export default function PedidosRecientes() {
    const [pedidos, setPedidos] = useState([]);
    const [mesas, setMesas] = useState({});
    const [loading, setLoading] = useState(true);
    const [pedidoDetalle, setPedidoDetalle] = useState(null);

    useEffect(() => {
        cargarMesas();
        cargarPedidos();
    }, []);

    const cargarMesas = async () => {
        try {
            const res = await fetch(`${baseURL}/mesaGet.php`);
            const data = await res.json();
            if (data && data.mesas) {
                const map = {};
                data.mesas.forEach(m => { map[m.idMesa] = m.mesa; });
                setMesas(map);
            }
        } catch (e) {
            console.error('Error al cargar mesas:', e);
        }
    };

    const cargarPedidos = async () => {
        setLoading(true);
        try {
            const res = await fetch(`${baseURL}/pedidoGet.php`);
            const data = await res.json();
            if (data && data.pedidos) {
                setPedidos(data.pedidos.reverse().slice(0, 10));
            }
        } catch (e) {
            console.error('Error al cargar pedidos:', e);
        } finally {
            setLoading(false);
        }
    };

    const getOrigenBadge = (origen) => {
        switch (origen) {
            case 'qr':
                return <span className="origenBadge badge-qr"><FontAwesomeIcon icon={faQrcode} /> QR Mesa</span>;
            case 'mesero':
                return <span className="origenBadge badge-mesero"><FontAwesomeIcon icon={faUserTie} /> Mesero</span>;
            case 'pos':
                return <span className="origenBadge badge-pos"><FontAwesomeIcon icon={faCashRegister} /> POS</span>;
            default:
                return <span className="origenBadge badge-default">Tienda</span>;
        }
    };

    const getEstadoBadge = (estado) => {
        const est = (estado || '').toLowerCase().replace(/\s+/g, '-');
        return <span className={`estadoBadge status-${est}`}>{estado || 'Pendiente'}</span>;
    };

    const getPagoBadge = (estadoPago, metodoPago) => {
        const confirmado = estadoPago === 'confirmado';
        return (
            <span className={`pagoBadge ${confirmado ? 'pago-confirmado' : 'pago-pendiente'}`}>
                {confirmado ? 'Pagado' : 'Pendiente'} • {metodoPago || 'Efectivo'}
            </span>
        );
    };

    const parseProductos = (raw) => {
        if (!raw) return [];
        if (Array.isArray(raw)) return raw;
        try {
            return JSON.parse(raw);
        } catch (e) {
            return [];
        }
    };

    return (
        <div className="pedidosRecientesCard">
            <div className="pedidosRecientesHeader">
                <div>
                    <h3>📋 Pedidos Recientes</h3>
                    <p>Últimos pedidos registrados en mesas, mostrador y pedidos para llevar</p>
                </div>
                <div className="pedidosRecientesActions">
                    <button className="btnReloadSmall" onClick={cargarPedidos} title="Recargar">
                        <FontAwesomeIcon icon={faSync} className={loading ? 'fa-spin' : ''} />
                    </button>
                    <Anchor to="/dashboard/pedidos" className="btnVerTodosPedidos">
                        Ver Todos
                    </Anchor>
                </div>
            </div>

            {loading ? (
                <div className="pedidosCargando">Cargando pedidos recientes...</div>
            ) : pedidos.length === 0 ? (
                <div className="noPedidosRecientes">No hay pedidos registrados recientemente</div>
            ) : (
                <div className="pedidosTableResponsive">
                    <table className="recientesTable">
                        <thead>
                            <tr>
                                <th># ID</th>
                                <th>Fecha / Hora</th>
                                <th>Cliente / Mesa</th>
                                <th>Origen</th>
                                <th>Total</th>
                                <th>Estado Pago</th>
                                <th>Estado Pedido</th>
                                <th style={{ textAlign: 'center' }}>Detalle</th>
                            </tr>
                        </thead>
                        <tbody>
                            {pedidos.map(p => {
                                const mesaNombre = mesas[p.idMesa] || (p.idMesa ? `Mesa #${p.idMesa}` : 'Para llevar');
                                return (
                                    <tr key={p.idPedido}>
                                        <td><strong>#{p.idPedido}</strong></td>
                                        <td className="colFecha">
                                            <FontAwesomeIcon icon={faClock} /> {p.createdAt}
                                        </td>
                                        <td>
                                            <div className="colClienteMesa">
                                                <strong>{mesaNombre}</strong>
                                                <span>{p.nombre || 'Cliente Mostrador'}</span>
                                            </div>
                                        </td>
                                        <td>{getOrigenBadge(p.origen)}</td>
                                        <td className="colTotal">
                                            <strong>{moneda} {parseFloat(p.total).toFixed(2)}</strong>
                                        </td>
                                        <td>{getPagoBadge(p.estadoPago, p.metodoPago)}</td>
                                        <td>{getEstadoBadge(p.estado)}</td>
                                        <td style={{ textAlign: 'center' }}>
                                            <button
                                                className="btnVerDetallePedido"
                                                onClick={() => setPedidoDetalle(p)}
                                                title="Ver detalle"
                                            >
                                                <FontAwesomeIcon icon={faEye} />
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </div>
            )}

            {/* Modal Detalle de Pedido */}
            {pedidoDetalle && (
                <div className="modalDetalleOverlay">
                    <div className="modalDetalleContent">
                        <div className="modalDetalleTop">
                            <div>
                                <h3>Pedido #{pedidoDetalle.idPedido}</h3>
                                <span className="modalMesaSubtitle">
                                    {mesas[pedidoDetalle.idMesa] || (pedidoDetalle.idMesa ? `Mesa #${pedidoDetalle.idMesa}` : 'Para llevar')} • {pedidoDetalle.nombre || 'Cliente'}
                                </span>
                            </div>
                            <button className="btnCloseModalDetalle" onClick={() => setPedidoDetalle(null)}>
                                <FontAwesomeIcon icon={faTimes} />
                            </button>
                        </div>

                        <div className="modalDetalleMetaGrid">
                            <div>
                                <small>Origen:</small>
                                <div>{getOrigenBadge(pedidoDetalle.origen)}</div>
                            </div>
                            <div>
                                <small>Estado:</small>
                                <div>{getEstadoBadge(pedidoDetalle.estado)}</div>
                            </div>
                            <div>
                                <small>Pago:</small>
                                <div>{getPagoBadge(pedidoDetalle.estadoPago, pedidoDetalle.metodoPago)}</div>
                            </div>
                            <div>
                                <small>Fecha:</small>
                                <strong>{pedidoDetalle.createdAt}</strong>
                            </div>
                        </div>

                        {pedidoDetalle.nota && (
                            <div className="modalDetalleNota">
                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                <span><strong>Observación:</strong> {pedidoDetalle.nota}</span>
                            </div>
                        )}

                        <h4>Productos del Pedido:</h4>
                        <div className="modalDetalleProductosList">
                            {parseProductos(pedidoDetalle.productos).map((prod, idx) => (
                                <div key={idx} className="detalleProdRow">
                                    <span className="prodQtyBadge">x{prod.cantidad}</span>
                                    <div className="prodDescCol">
                                        <strong>{prod.titulo}</strong>
                                        {prod.item && <span className="prodSubitem">{prod.item}</span>}
                                    </div>
                                    <strong className="prodSubtotalCol">
                                        {moneda} {(parseFloat(prod.precio || 0) * (prod.cantidad || 1)).toFixed(2)}
                                    </strong>
                                </div>
                            ))}
                        </div>

                        <div className="modalDetalleTotalRow">
                            <span>Total General:</span>
                            <h2>{moneda} {parseFloat(pedidoDetalle.total).toFixed(2)}</h2>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
